import { SegmentedControl, SegmentedControlItem } from '@astryxdesign/core/SegmentedControl';
import { CalendarRange, Rows3 } from 'lucide-react';
import type { ReportView } from '../lib/view-preference';

interface ViewSelectorProps {
  value: ReportView;
  onChange: (view: ReportView) => void;
}

export default function ViewSelector({ value, onChange }: ViewSelectorProps) {
  return (
    <SegmentedControl
      label="Visualización del parte"
      value={value}
      onChange={(nextValue) => onChange(nextValue === 'timeline' ? 'timeline' : 'grouped')}
      size="sm"
    >
      <SegmentedControlItem value="timeline" label="Timeline" icon={<CalendarRange size={14} />} />
      <SegmentedControlItem value="grouped" label="Agrupado" icon={<Rows3 size={14} />} />
    </SegmentedControl>
  );
}
